import Tooltip from "bootstrap/js/dist/tooltip";

// ✅ Détruit tous les tooltips en cours
export const destroyAllTooltips = () => {
  const tooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');

  tooltips.forEach((el) => {
    try {
      const instance = Tooltip.getInstance(el);
      if (instance) {
        instance.hide();
        instance.dispose();
      }
    } catch (err) {
      console.warn("Tooltip destruction échouée pour:", el, err);
    }
  });
};

// ✅ Initialise tous les tooltips qui ne le sont pas encore
export const initTooltips = () => {
  const elements = document.querySelectorAll('[data-bs-toggle="tooltip"]');

  elements.forEach((el) => {
    try {
      if (!Tooltip.getInstance(el)) {
        new Tooltip(el);
      }
    } catch (err) {
      console.warn("Tooltip init échoué pour:", el, err);
    }
  });
};

// ✅ OBSERVER : Regénère les tooltips dès qu’un nouveau tooltip apparaît
let tooltipTimeout;
export const watchTooltips = () => {
  const observer = new MutationObserver(() => {
    clearTimeout(tooltipTimeout);
    tooltipTimeout = setTimeout(() => {
      initTooltips();
    }, 50); // debounce pour éviter les spam d’inits
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  return () => {
    observer.disconnect();
    clearTimeout(tooltipTimeout);
  };
};
